import { apiClient } from './apiClient'
import type { RailCar, Track } from '../types/interchange'

export function getRoutableTracks(facilityId: string): Promise<Track[]> {
  return apiClient.get<Track[]>(`/api/v1/tracks/routable?facilityId=${facilityId}`)
}

export function getTrackOccupancy(trackId: string): Promise<Track> {
  return apiClient.get<Track>(`/api/v1/tracks/${trackId}/occupancy`)
}

export function getTrackRailCars(trackId: string): Promise<RailCar[]> {
  return apiClient.get<RailCar[]>(`/api/v1/tracks/${trackId}/railcars`)
}
